import {Map, fromJS, List} from "immutable";

import {
    GET_RECEIPTS_SUCCESS,
    GET_RECEIPTS_REQUEST,
    GET_RECEIPTS_ERROR,

    GET_RECEIPT_REQUEST,
    GET_RECEIPT_SUCCESS,
    GET_RECEIPT_ERROR,

    CREATE_RECEIPT_REQUEST,
    CREATE_RECEIPT_SUCCESS,
    CREATE_RECEIPT_ERROR,

    UPDATE_RECEIPT_REQUEST,
    UPDATE_RECEIPT_SUCCESS,
    UPDATE_RECEIPT_ERROR,

    UPLOAD_RECEIPT_FILES_REQUEST,
    UPLOAD_RECEIPT_FILES_PROGRESS,
    UPLOAD_RECEIPT_FILES_SUCCESS,
    UPLOAD_RECEIPT_FILES_ERROR,

    DELETE_RECEIPT_FILE_REQUEST,
    DELETE_RECEIPT_FILE_SUCCESS,
    DELETE_RECEIPT_FILE_ERROR,

    DELETE_RECEIPT_REQUEST,
    DELETE_RECEIPT_SUCCESS,
    DELETE_RECEIPT_ERROR,

    CLEAN_RECEIPTS
} from '../actions/receipts';

const receipts = (state = Map({
  payload: List([]),
  isFetching: false,
    isUploading: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_RECEIPTS_REQUEST:
      case GET_RECEIPT_REQUEST:
      case CREATE_RECEIPT_REQUEST:
      case UPDATE_RECEIPT_REQUEST:
      case DELETE_RECEIPT_FILE_REQUEST:
      case DELETE_RECEIPT_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_RECEIPT_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_RECEIPT_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_RECEIPTS_SUCCESS:
      case GET_RECEIPT_SUCCESS:
      case CLEAN_RECEIPTS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_RECEIPT_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_RECEIPT_SUCCESS:
      case UPLOAD_RECEIPT_FILES_SUCCESS:
      case DELETE_RECEIPT_FILE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_RECEIPT_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_RECEIPTS_ERROR:
      case GET_RECEIPT_ERROR:
      case CREATE_RECEIPT_ERROR:
      case UPDATE_RECEIPT_ERROR:
      case UPLOAD_RECEIPT_FILES_ERROR:
      case DELETE_RECEIPT_FILE_ERROR:
      case DELETE_RECEIPT_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default receipts;



// WEBPACK FOOTER //
// ./src/reducers/receipts.js